import { render, staticRenderFns } from "./ButtonItem.vue?vue&type=template&id=08c7c97b&scoped=true&lang=pug&"
import script from "./ButtonItem.vue?vue&type=script&lang=js&"
export * from "./ButtonItem.vue?vue&type=script&lang=js&"
import style0 from "./ButtonItem.vue?vue&type=style&index=0&id=08c7c97b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7c97b",
  null
  
)

component.options.__file = "ButtonItem.vue"
export default component.exports